import React from "react";
import { UserRole } from "../__generated__/globalTypes";
import Helmet from "react-helmet";
import { Button } from "../components/button";
import { useMe } from "../hooks/useMe";
import { useHistory } from "react-router-dom";


export const Profile = () => {
    const { data: userData } = useMe();
    const history = useHistory();

    return (
        <div className="h-screen flex items-center flex-col pt-10 lg:pt-5 text-white">
            <Helmet>
                <title>Profile | KUDOK</title>
            </Helmet>
            <div className="w-full max-w-screen-sm flex flex-col px-5 items-center">
                <h4 className="w-full font-medium text-center text-3xl mb-5">
                    Profile
                </h4>
            </div>
            < div className="p-5 border rounded text-center text-white-500" >
                <img className="w-32 h-32 rounded-full mx-auto" src="/images/profile.png" alt="Avatar of Jonathan Reinink" />
                <div className="text-sm mt-5">
                    <a href="#" className="font-medium leading-none text-white-900 hover:text-indigo-600 transition duration-500 ease-in-out">{userData?.me.email}</a>
                    <p>{userData?.me.role}</p>
                </div>

                <p className="mt-2 text-sm">Lorem ipsum dolor sit amet, consecte adipisicing elit.Voluptatibus quia Maiores et perferendis eaque.</p>

                <div className="flex mt-4 justify-center">
                    <a href="/" className="w-6 mx-1">
                        <img src="/images/twitter.svg" className="w-52 mb-10" alt="" />
                    </a>
                    <a href="/" className="w-6 mx-1">
                        <img src="/images/twitter.svg" className="w-52 mb-10" alt="" />
                    </a>
                    <a href="/" className="w-6 mx-1">
                        <img src="/images/twitter.svg" className="w-52 mb-10" alt="" />
                    </a>
                    <a href="/" className="w-6 mx-1">
                        <img src="/images/twitter.svg" className="w-52 mb-10" alt="" />
                    </a>
                </div>

                <Button
                    canClick={true}
                    loading={false}
                    actionText={"Edit Profile"}
                    onClick={() => { history.push("/edit-profile") }}
                />
            </div>
        </div >
    )

};